export const DEFAULT_REDIRECT_PATH = "/auth/redirect";

const URI_SCHEME_PATTERN = /^[a-zA-Z][a-zA-Z\d+\-.]*:/;
const ASCII_CONTROL_CHAR_PATTERN = /[\u0000-\u001F]/;

export function getValidatedRedirectPath(
  input: string | null | undefined,
  fallback: string = DEFAULT_REDIRECT_PATH
): string {
  if (typeof input !== "string") {
    return fallback;
  }

  if (!input.startsWith("/") || input.startsWith("//")) {
    return fallback;
  }

  if (URI_SCHEME_PATTERN.test(input)) {
    return fallback;
  }

  if (ASCII_CONTROL_CHAR_PATTERN.test(input)) {
    return fallback;
  }

  return input;
}

export function buildLoginPathWithRedirect(redirectTo: string): string {
  const safeRedirectTo = getValidatedRedirectPath(redirectTo, DEFAULT_REDIRECT_PATH);
  return `/login?redirectTo=${encodeURIComponent(safeRedirectTo)}`;
}
